import { Component, Input, Output } from '@angular/core';

@Component({
    selector: 'app-user-profil-type',
    templateUrl: './user-profil-type.component.html',
    styleUrls: ['./user-profil-type.component.sass'],
    standalone: false
})

export class UserProfilTypeComponent {

  @Input() selected: boolean = false;
  @Input() icon: string = '';
  @Input() accountType: string = '';
  @Input() description: string = '';
  @Input() secLine: string = '';

}